import React from 'react';
import classNames from 'classnames';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import useApplicationVariableList from '../../../utils/CustomHooks/useApplicationVariableList';
import { callCrewNavi } from '../../../external/GinieBrowser/SelectTabPage';

interface SideNavItemForManualProps extends RouteComponentProps {
  className?: string;
  to: string;
  children: React.ReactNode;
}

const SideNavItemForManual: React.FC<SideNavItemForManualProps> = ({ to, children, className }) => {
  const { getApplicationVariableByReferenceCd } = useApplicationVariableList();
  const crewNaviUrl = getApplicationVariableByReferenceCd('STR_U_0027') as string[];

  return (
    <li className={classNames('uc-sidenav__nav-item', className)}>
      <Link to={to} onClick={() => callCrewNavi(crewNaviUrl[0])} data-testid='open-crewnavi--event' data-testid-e2e={`sideNavItem-link`}>
        {children}
      </Link>
    </li>
  );
};

export default withRouter(SideNavItemForManual);
